module.exports = __webpack_public_path__ + "media/marketplace_fund/hero-05d8de3d.png";